function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "icon-tertiary",
  d: "M 1,72.5 C 1,33.012 33.01,1 72.5,1 111.99,1 144,33.012 144,72.5 144,111.989 111.99,144 72.5,144 33.01,144 1,111.989 1,72.5 Z",
  stroke: "#002060",
  strokeWidth: 2.29167,
  strokeMiterlimit: 8,
  fill: "#ffffff",
  fillRule: "evenodd"
});
var _ref3 = /*#__PURE__*/React.createElement("g", {
  className: "icon-tertiary"
}, React.createElement("path", {
  fillRule: "evenodd",
  fill: "none",
  strokeMiterlimit: 10,
  strokeLinejoin: "round",
  strokeLinecap: "round",
  strokeWidth: 2.29167,
  d: "m 28,89 c 0,-24.3 19.7,-44 44,-44 24.3,0 44,19.7 44,44 0,24.301 -19.7,44 -44,44 -24.3,0 -44,-19.699 -44,-44 z"
}), React.createElement("path", {
  fillRule: "evenodd",
  fill: "none",
  strokeMiterlimit: 10,
  strokeLinejoin: "round",
  strokeLinecap: "round",
  strokeWidth: 2.29167,
  d: "M 49,89 C 49,64.7 59.3,45 72,45 84.7,45 95,64.7 95,89 95,113.301 84.7,133 72,133 59.3,133 49,113.301 49,89 Z"
}), React.createElement("path", {
  fillRule: "evenodd",
  fill: "none",
  strokeMiterlimit: 8,
  strokeWidth: 2.29167,
  d: "m 72,45 v 87.806"
}), React.createElement("path", {
  fillRule: "evenodd",
  fill: "none",
  strokeMiterlimit: 8,
  strokeWidth: 2.29167,
  d: "M 104.33,60.639 C 95.58,69.814 74.02,73.608 56.16,69.114 48.77,67.251 42.83,64.142 39.36,60.304"
}), React.createElement("path", {
  fillRule: "evenodd",
  fill: "none",
  strokeMiterlimit: 8,
  strokeWidth: 2.29167,
  d: "M 104.3289,118.3613 C 95.582,109.186 74.017,105.3917 56.1623,109.8867 c -7.3974,1.8622 -13.32818,4.9718 -16.8028,8.8098"
}), React.createElement("path", {
  fillRule: "evenodd",
  fill: "none",
  strokeMiterlimit: 8,
  strokeWidth: 2.29167,
  d: "m 28,89 87.81,0.001"
}));
var _ref4 = /*#__PURE__*/React.createElement("g", {
  className: "icon-tertiary",
  fill: "#adb9ca",
  stroke: "#002060"
}, React.createElement("path", {
  d: "M 63.1126,85.5969 62.0664,72.7641 C 77.016268,66.5786 81.49466,53.6111 72.06918,43.80021 62.6437,33.989363 42.8836,31.05042 27.9337,37.23589 12.9838,43.42136 8.5054,56.3889 17.9309,66.1998 c 6.957,7.2414 19.9154,10.9867 32.7525,9.4663 z",
  strokeWidth: 2.29167,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  fillRule: "evenodd",
  className: "icon-secondary"
}));
var _ref5 = /*#__PURE__*/React.createElement("g", {
  className: "icon-tertiary",
  fill: "#ffffff"
}, React.createElement("path", {
  fillRule: "evenodd",
  strokeMiterlimit: 10,
  strokeLinejoin: "round",
  strokeLinecap: "round",
  strokeWidth: 2.29167,
  d: "m 23,55 c 0,-2.761 2.24,-5 5,-5 2.76,0 5,2.239 5,5 0,2.761 -2.24,5 -5,5 -2.76,0 -5,-2.239 -5,-5 z"
}), React.createElement("path", {
  fillRule: "evenodd",
  strokeMiterlimit: 10,
  strokeLinejoin: "round",
  strokeLinecap: "round",
  strokeWidth: 2.29167,
  d: "m 40,55 c 0,-2.761 2.24,-5 5,-5 2.76,0 5,2.239 5,5 0,2.761 -2.24,5 -5,5 -2.76,0 -5,-2.239 -5,-5 z"
}), React.createElement("path", {
  fillRule: "evenodd",
  strokeMiterlimit: 10,
  strokeLinejoin: "round",
  strokeLinecap: "round",
  strokeWidth: 2.29167,
  d: "m 57,55 c 0,-2.761 2.24,-5 5,-5 2.76,0 5,2.239 5,5 0,2.761 -2.24,5 -5,5 -2.76,0 -5,-2.239 -5,-5 z"
}));
var _ref6 = /*#__PURE__*/React.createElement("g", {
  className: "icon-tertiary",
  stroke: "#002060"
}, React.createElement("path", {
  d: "M 90.1847,73.9993 94.1605,58.1907 C 110.88704,55.002 120.56911,43.3773 115.78605,32.2263 111.00299,21.07532 93.566,14.6206 76.8395,17.809313 60.113,20.99802 50.431,32.6227 55.214,43.7737 c 3.5304,8.2305 14.2012,14.2086 26.9706,15.1096 z",
  strokeWidth: 2.29167,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  fill: "#ecaec6",
  fillRule: "evenodd",
  className: "icon-primary"
}));
var _ref7 = /*#__PURE__*/React.createElement("g", {
  className: "icon-tertiary",
  fill: "#ffffff"
}, React.createElement("path", {
  fillRule: "evenodd",
  strokeMiterlimit: 10,
  strokeLinejoin: "round",
  strokeLinecap: "round",
  strokeWidth: 2.29167,
  d: "M 108,37.99998 C 108,35.23857 105.76143,33 103.00002,33 c -2.76142,0 -4.99999,2.23857 -4.99999,4.99998 0,2.76142 2.23857,4.99999 4.99999,4.99999 2.76141,0 4.99998,-2.23857 4.99998,-4.99999 z"
}), React.createElement("path", {
  fillRule: "evenodd",
  strokeMiterlimit: 10,
  strokeLinejoin: "round",
  strokeLinecap: "round",
  strokeWidth: 2.29167,
  d: "M 91,37.99998 C 91,35.23857 88.76135,33 85.99984,33 c -2.76152,0 -5.00014,2.23857 -5.00014,4.99998 0,2.76142 2.23862,4.99999 5.00014,4.99999 C 88.76135,42.99997 91,40.7614 91,37.99998 Z"
}), React.createElement("path", {
  fillRule: "evenodd",
  strokeMiterlimit: 10,
  strokeLinejoin: "round",
  strokeLinecap: "round",
  strokeWidth: 2.29167,
  d: "M 73,37.99998 C 73,35.23857 70.76143,33 68.00002,33 c -2.76142,0 -4.99999,2.23857 -4.99999,4.99998 0,2.76142 2.23857,4.99999 4.99999,4.99999 C 70.76143,42.99997 73,40.7614 73,37.99998 Z"
}));
var SvgSurveyModelTabLanguage = function SvgSurveyModelTabLanguage(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, ["svgRef"]);
  return React.createElement("svg", _extends({
    overflow: "hidden",
    height: 40,
    width: 40,
    viewBox: "0 0 145 145",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};
var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSurveyModelTabLanguage, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Survey-Model-Tab-Language.06e7828b.svg";
export { ForwardRef as ReactComponent };